import { useDispatch, useSelector } from "react-redux";
import { openProductRecallModal, closeProductRecallModal } from "../store";
import React, { useEffect } from "react";

import "./LinkList.css";

function LinkList({ links }) {
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("LinkList rendered");
  }, []);

  return (
    <ul className="link-list">
      {links.map((link, index) => (
        link.href === "#palautemenettely" ? <li key={index}>
          <a href={link.href} onClick={() => {
            dispatch(openProductRecallModal());
            return false;
          }}>
            {link.label}
          </a>
        </li> :
        <li key={index}>
          <a href={link.href} target={link.target || "_self"}>
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default LinkList;
